import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import SingleTaskManager from "../../PagesManager/SingleTaskManager";
import { useDispatch, useSelector } from "react-redux";
import { GetAllTasks } from "../../Redux/Reducers/TasksManager";
import LoaderAHSF from "../../Components/LoaderAHSF";

const SingelTaskManagerContainer = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      TasksManager: state.TasksManager.TasksManager,
      loadingTasksManager: state.TasksManager.loadingTasksManager,
      refreshTableStatus: state.refreshTableStatus.refreshTable,
    };
  });
  const [tasksList, setTasksList] = useState({ ...state.TasksManager });

  //[,]
  //to get data for tasks by application Guid
  useEffect(() => {
    dispatch(GetAllTasks(localStorage.getItem("aI_ApplicationInformationId_Manager")));
  }, [state.refreshTableStatus]);
    //[,]
  //to assigin data in taskslist after get data ends
  useEffect(() => {
    if (!state.loadingTasksManager) {
      setTasksList({ ...state.TasksManager });
    }
  }, [state.loadingTasksManager]);
  //console.log(state.loadingTasksManager, "tasks", state.TasksManager);

 

  return (
    <>
      {!state.loadingTasksManager ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName="المهام"
            child={[
              <SingleTaskManager
                tasks={state.TasksManager}
                hasPermission={true}
              />,
            ]}
          />
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingTasksManager} />
    </>
  );
};

export default SingelTaskManagerContainer;
